/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { ResourceThumbnailUrlsAnyOf } from './resourceThumbnailUrlsAnyOf';

export type ResourceThumbnailUrls = ResourceThumbnailUrlsAnyOf | null;
